import Controller from 'controllers/controller';
import Elements from 'tools/elements';
import EventManager from 'tools/event-manager';
import Animator from 'tools/animator';

class ModalController extends Controller {
    constructor(app, modal) {
        super(app);
        
        this.modal = modal;
        this.id = this.modal.getAttribute('id');
        this.elements = new Elements(this.modal);
        this.animator = new Animator({
            elements: this.elements.all()
        });
        this.events = new EventManager({
            bind: this
        });
        
        this.cacheElements();
        this.attachEvents();
    }
    
    cacheElements() {
        this.elements.save('modal', this.modal);
        this.elements.queryOne('close', '.close-modal');
        this.elements.queryOne('title', '.title');
        this.elements.queryOne('content', '.content');
        this.elements.queryOne('backdrop', '.backdrop');
    }
    
    attachEvents() {
        this.events.on(this.elements.get('close'), 'click', this.manualClose);
        this.events.on(this.elements.get('backdrop'), 'click', this.manualClose);
    }
    
    manualClose() {
        this.close(true);
    }

    removeEvents() {
        this.events.off();
        this.app.modalsController.off('backdrop-clicked', this.close);
    }

    /**
     * Set the title of the modal.
     * 
     * @param title
     */
    setTitle(title) {
        if (this.elements.has('title')) {
            this.elements.get('title').innerHTML = title;
        }
    }

    /**
     * Set the content of the modal.
     * 
     * @param html
     */
    setContent(html) {
        this.elements.get('content').innerHTML = html;
    }

    /**
     * If the modal was closed via a direct user action, pass true.
     * 
     * @param manual - If the modal was closed via a direct user action, pass true.
     * 
     * @return {Promise<void>}
     */
    async close(manual = false) {
        this.app.modalsController.hideBackdrop();
        
        await this.animator.to('modal', {
            y: -30,
            opacity: 0
        });

        this.animator.set('modal', {
            display: 'none'
        });

        this.elements.get('modal').classList.remove('is-open');

        this.app.modalsController.emit(this.id + '-closed', manual);
    }
    
    async open(manual = false) {
        this.app.modalsController.showBackdrop();
        
        await this.animator.fromTo('modal', {
            display: 'block',
            y: -30,
            opacity: 0
        }, {
            y: 0,
            opacity: 1
        });

        this.elements.get('modal').classList.add('is-open');

        this.app.modalsController.emit(this.id + '-openned', manual);
    }
    
    destroy() {
        this.removeEvents();
    }
}

export default ModalController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/components/modal.js